import { Flex } from '@chakra-ui/react';
import {
  GET_PROJECT_LISTING_DATA,
  GET_PROJECT_TYPE_CREATION_META,
  GET_PROJECT_TYPE_EDIT_AND_DELETE,
  GET_PROJECT_TYPE_EDIT_PREFILL_DATA,
  PROJECT_TYPE_CUD,
} from 'api/urls/projects';
import AppButton from 'components/AppButton/AppButton';
import AppInput from 'components/AppInput/AppInput';
import AppLoader from 'components/AppLoader/AppLoader';
import AppSelect from 'components/AppSelect/AppSelect';
import GetOptionForSingleSelect from 'components/GetOptionsForSingleSelect/GetOptionsForSingleSelect';
import AppText from 'components/typography/AppText';
import useHandleAddAndEdit from 'hooks/formHelpers/useHandleAddAndEdit';
import React, { useState } from 'react';
import { MdArrowDropDown } from 'react-icons/md';
import { useQueryClient } from 'react-query';

const AddAndEditProject = ({
  onClose,
  isEdit,
  isDelete,
  currentId,
  getTableDataMutation,
}) => {
  const [formValues, setFormValues] = useState({
    identity: '',
    status: '',
  });

  const formFields = [
    {
      fieldPlaceholder: 'Project Type',
      fieldType: 'text',
      fieldName: 'identity',
      isRequired: true,
    },
  ];

  const formSelectFields = [
    {
      fieldPlaceholder: 'Status',
      fieldName: 'status',
      fieldMetaName: 'statuses',
      isRequired: true,
    },
  ];

  const queryClient = useQueryClient();

  const {
    metaData,
    initialValues,
    isLoading,
    isSubmitLoading,
    handleFormSubmit,
    deleteMutation,
    formError,
  } = useHandleAddAndEdit({
    baseMetaUrl: GET_PROJECT_TYPE_CREATION_META,
    prefillMetaUrl: GET_PROJECT_TYPE_EDIT_PREFILL_DATA(currentId),
    createUrl: PROJECT_TYPE_CUD,
    editAndDeleteUrl: GET_PROJECT_TYPE_EDIT_AND_DELETE(currentId),
    isEdit: isEdit,
    formValues: formValues,
    setFormValues: setFormValues,
    onClose: onClose,
    toastText: 'project type',
    onCreateEditSuccess: () => {
      getTableDataMutation();
      queryClient.invalidateQueries(GET_PROJECT_LISTING_DATA);
    },
  });

  const closeHandler = () => {
    onClose();
  };

  const handleDelete = () => {
    deleteMutation();
    onClose();
  };

  if (isDelete) {
    return (
      <>
        <AppText
          text="Are you sure you wanna delete this project type"
          customStyles={{ mb: 5, textAlign: 'center' }}
        />
        <Flex>
          <AppButton
            text="Cancel"
            variant="cancelBtn"
            customStyles={{ margin: '0px 22px 27px 22px' }}
            onClick={closeHandler}
          />
          <AppButton
            isLoading={isSubmitLoading}
            text="Delete"
            variant="deleteBtn"
            onClick={handleDelete}
            customStyles={{ margin: '0px 22px 27px 0px' }}
          />
        </Flex>
      </>
    );
  } else {
    return (
      <form onSubmit={handleFormSubmit}>
        <AppLoader height="100px" isLoading={isLoading}>
          {!isLoading && (
            <>
              {formFields.map((field) => (
                <>
                  <AppInput
                    {...field}
                    key={field.fieldName}
                    formValues={formValues}
                    setFormValues={setFormValues}
                    fieldError={formError}
                    label={isEdit ? field.fieldPlaceholder : ''}
                    innerLabel={isEdit ? true : false}
                    isRequired={field.isRequired}
                  />
                </>
              ))}

              {formSelectFields.map((field, i) => (
                <div style={{ marginBottom: '1.25rem' }} key={i}>
                  <AppSelect
                    variant="filled"
                    icon={MdArrowDropDown}
                    customStyles={{ fontSize: '14px' }}
                    formValues={formValues}
                    fieldName={field.fieldName}
                    setFormValues={setFormValues}
                    fieldError={formError}
                    label={isEdit ? field.fieldPlaceholder : ''}
                  >
                    <option value="" hidden>
                      {field.fieldPlaceholder}
                    </option>
                    <GetOptionForSingleSelect
                      data={metaData?.[field.fieldMetaName]}
                      initial={initialValues?.[field.fieldName]}
                    />
                  </AppSelect>
                </div>
              ))}
              <Flex>
                <AppButton
                  text="Cancel"
                  variant="cancelBtn"
                  customStyles={{ margin: '0px 22px 27px 22px' }}
                  onClick={closeHandler}
                />
                <AppButton
                  isLoading={isSubmitLoading}
                  type="submit"
                  text={isEdit ? 'Save' : 'Create'}
                  customStyles={{ margin: '0px 22px 27px 0px' }}
                />
              </Flex>
            </>
          )}
        </AppLoader>
      </form>
    );
  }
};

export default AddAndEditProject;
